import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { customerLogos } from "@/data/customerLogos";

export function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="py-20 lg:py-28 bg-secondary/50">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <h2 className="text-3xl md:text-4xl font-medium font-heading text-primary tracking-tight">
            {t("customerCases.testimonials.title")}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {(["elon", "airmee"] as const).map((key, index) => (
            <motion.div
              key={key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="bg-card rounded-xl p-8 shadow-sm border border-border"
            >
              <img
                src={customerLogos.find(l => l.name.toLowerCase() === key.toLowerCase())?.src}
                alt={`${t(`customerCases.testimonials.${key}.company`)} logotyp`}
                width={80}
                height={32}
                className="h-8 w-auto object-contain mb-6"
                loading="lazy"
                style={{ aspectRatio: '80/32' }}
              />
              <Quote className="h-8 w-8 text-coral/30 mb-4" aria-hidden="true" />
              <blockquote className="text-foreground font-body leading-relaxed mb-6 italic">
                &ldquo;{t(`customerCases.testimonials.${key}.quote`)}&rdquo;
              </blockquote>
              <div className="border-t border-border pt-4">
                <p className="font-semibold text-foreground text-sm">
                  {t(`customerCases.testimonials.${key}.author`)}
                </p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {t(`customerCases.testimonials.${key}.role`)}, {t(`customerCases.testimonials.${key}.company`)}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
